import { apiService } from "../../../../services/apiService";
import { apiServiceConstants } from "../../../../constants";
import { utilService } from "../../../../services/utilService";
import { HelpData, helpParams, RespHelpInterface, RespHelpModel } from "./Help.model";

const getHelpDetails = async (params: helpParams): Promise<RespHelpInterface> => {
    const respApiResult = await apiService
      .apiCall(
        `user/help/?reg_code=${utilService.getNetwork()}`,
        params,
        apiServiceConstants.GET,
        utilService.getDeviceType()
      )
      .then((res) => {
        const helpResp = res as RespHelpModel;
        const helpResponse =
          setHelpModel(
            helpResp
          );
        const result: RespHelpInterface = {
          isSuccess: helpResp.isSuccess,
          displayHelpContainer: helpResponse,
          status: helpResp.status,
          message: helpResp.message,
        };
        return result;
      })
      .catch((err) => {
        const result: RespHelpInterface = {
          isSuccess: false,
          message: err.message,
          status: err.status,
          displayHelpContainer : []
        };
        return result;
      });
  
    return respApiResult;
  };

  const setHelpModel = (payload: RespHelpModel): any => {
    let HelpListArray = payload.result?.map((object: any) => {
      return {
        count: object.count,
        next: object.next,
        previous: object.previous,
        data: mapData(object.data)
      };
    });
  
    return HelpListArray;
  }
  
  const mapData = (groupData: Array<HelpData>): any => {
    let HelpDataListArray = groupData.map((object: any) => {
  
      return {
        id: object.id,
        caption: object.caption,
        snapshot: object.snapshot,
        url: object.url,
        order: object.order,
        visibility: object.visibility
      };
    });

    return HelpDataListArray;
  };

const handleErrorResponse = () => { };

export const helpService = {
    getHelpDetails,
    handleErrorResponse,
};